import { Injectable, OnDestroy } from '@angular/core';
import { LastChangeLogModel, ChangeLogsModel, ChangesModel } from '../../models/changelog.models';
import { LocalStorageUtility } from 'src/app/utilities/application.utility';
import { Observable, of } from 'rxjs';
import 'rxjs/add/operator/catch';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { assetUrl } from '../utilities';

/** Constants used into this service. */
export class ChangelogConsts {
  /**  */
  static readonly DefaultVersion: string = '1.0.0';
  /** Miglioramenti */
  static readonly DefaultDescriptionTitle: string = 'Miglioramenti';
  /** Corretti bug minori e migliorata la struttura del codice */
  static readonly DefaultDescription: string = 'Corretti bug minori e migliorata la struttura del codice';
  /** LastChanges */
  static readonly LastChanges: string = 'LastChanges';
  /** LastAuthUser */
  static readonly Username: string = 'LastAuthUser';
}

export enum LastChangeProperties {
  version = 'version',
  changeLogConsulted = 'changeLogConsulted',
  changeLogChanged = 'changeLogChanged',
}

@Injectable({
  providedIn: 'root',
})
export class ChangelogService implements OnDestroy {
  lastChangeIdentifier: string;
  changeData: ChangeLogsModel;

  // Contains data needed to visualization of changelog popup.
  private lastChange: LastChangeLogModel;
  // Current username from aws Cognito.
  private currentUsername: string;
  // List of changes contained into changelogs.json.

  get ChangeLogs() {
    return this.changeLogs;
  }
  private changeLogs: Array<ChangesModel>;

  /**
   * Initialize the service with external data...
   */
  constructor(private storage: LocalStorageUtility, private http: HttpClient) { }

  ngOnDestroy(): void {
    // Before destroy this component, change the state of changeLogAlreadyShown to false and save it.
    // In thi manner the changelog on new session will be shown.
    // ISBS-142 - CR - this.setLastChangelog(LastChangeProperties.changeLogAlreadyShown, false, true);
  }

  /**
   * Load last changes consulted from localStorage for current user..
   */
  private loadLastChanges(): boolean {
    let result: boolean;

    try {
      this.currentUsername = this.storage.getValueByName(ChangelogConsts.Username);

      // Load last change from local storage if not empty.
      if (this.currentUsername != null && this.currentUsername.length > 0) {
        // If have the user, i am already logged in.
        this.lastChangeIdentifier = ChangelogConsts.LastChanges + (this.currentUsername !== null && this.currentUsername !== '' ? '_' + this.currentUsername : '');
      } else {
        // If arrive from login, localStorage is empty...
        this.lastChangeIdentifier = this.storage.getKeyByName(ChangelogConsts.LastChanges);
        this.currentUsername = this.lastChangeIdentifier ? this.lastChangeIdentifier.replace(`${ChangelogConsts.LastChanges}_`, '') : '';
      }

      const lastChangesStr: string = localStorage.getItem(this.lastChangeIdentifier);

      // Carico i dati dell'ultimo changelog scritto.
      if (lastChangesStr !== null && lastChangesStr.length > 0) {
        this.lastChange = JSON.parse(lastChangesStr) as LastChangeLogModel;
        result = true;
      } else if (this.lastChange === null || this.lastChange === undefined) {
        this.lastChange = this.createLastChange();
      }
    } catch (e) {
      console.error(e);
      result = false;
    }

    return result;
  }

  private createLastChange(): LastChangeLogModel {
    return {
      changeLogChanged: false,
      changeLogConsulted: false,
      // ISBS-142 - CR - changeLogAlreadyShown: false,
      version: ChangelogConsts.DefaultVersion,
    } as LastChangeLogModel;
  }

  /**
   * Load the changelogs file from environment.
   */
  public loadChangeLogs(): Observable<any> {
    let that = this;
    let result: boolean;

    return this.http.get('/assets/changelogs.json').map((res: any) => {
      let data: any = res;

      that.changeData = data;
      if (that.changeData != null && that.changeData.changeLogs != null) {
        that.changeLogs = that.changeData.changeLogs.slice(0, that.changeData.numberPastVersions);
      } else {
        //that.createDefaultChangeLog();
      }

      /* ISBS-142 - CR - if (that.changeLogs != null && that.changeLogs.length >= 1) {
                        // Estraggo la prima versione disponibile, che dovrebbe essere l'ultima.
                        that.currentVersion = that.changeLogs[0].version;
                    } */
      return that.changeLogs;
    });
  }

  // private createDefaultChangeLog(): void {
  //   const modified: Date = new Date(document.lastModified);
  //   const strModified = moment(modified).format('DD/MM/YYYY');
  //   const changes: ChangeModel = {
  //     //date: strModified,
  //     description: ChangelogConsts.DefaultDescriptionTitle,
  //     changes: [],
  //   };
  //   const change: ChangeModel = {
  //     title: '',
  //     changeType: 'fixed',
  //     changeList: [],
  //   };
  //   const description: DescriptionModel = {
  //     description: ChangelogConsts.DefaultDescription,
  //     title: ChangelogConsts.DefaultDescriptionTitle,
  //     link: '',
  //   };
  //   change.changeList.push(description);
  //   changes.changes.push(change);
  //   this.changeLogs = [];
  //   this.changeLogs.push(changes);
  // }

  public loadChangelogFile(): Observable<boolean> {
    return this.loadChangeLogs().map((result) => {
      const isAlreadyConsulted: boolean = (this.lastChange != null && this.lastChange.changeLogConsulted) || false;
      const isVersionChanged: boolean = this.changeLogs != null && this.changeLogs.length > 0 && this.changeLogs[0].version !== (this.lastChange != null ? this.lastChange.version : ChangelogConsts.DefaultVersion);
      const isAlreadyShown: boolean = false;

      // ISBS-142 - CR - const isAlreadyShown : boolean = this.lastChange.changeLogAlreadyShown;

      let bResult: boolean = isVersionChanged || !isAlreadyConsulted;

      this.ChangeLogOnConsole(isAlreadyShown, isVersionChanged, isAlreadyConsulted, bResult);

      if (bResult) {
        bResult = bResult && !isAlreadyShown;

        if (this.lastChange == null || Object.keys(this.lastChange).length < 4) {
          this.lastChange = this.createLastChange();
        }

        // ISBS-142 - CR - this.lastChange.changeLogAlreadyShown = true;
        this.lastChange.changeLogChanged = false;

        if (this.changeLogs && this.changeLogs.length > 0) {
          this.lastChange.version = this.changeLogs[0].version;
        }

        this.saveLastChanges();
      }

      return bResult;
    });
  }

  private ChangeLogOnConsole(isAlreadyShown: boolean, isVersionChanged: boolean, isAlreadyConsulted: boolean, bResult: boolean) {
    if (environment.canLogConsole === true) {
      // ISBS-142 - CR - console.log(`lastChange.changeLogAlreadyShown: ${this.lastChange.changeLogAlreadyShown ? 'true' : 'false'}`);
      // console.log(`changelog.isAlreadyShown: ${isAlreadyShown ? 'true' : 'false'}`);
      // console.log(`changelog.lastChange.changeLogConsulted: ${this.lastChange.changeLogConsulted ? 'true' : 'false'}`);
      // console.log(`changelog.lastChange.changeLogChanged: ${this.lastChange.changeLogChanged ? 'true' : 'false'}`);
      // console.log(`changelog.canShown: ${isVersionChanged} || !(${isAlreadyConsulted} || ${isAlreadyShown}) = ${bResult}`);
    }
  }

  /**
   * Salvo i dati accumulati in lastChanges per l'utente corrente.
   */
  public saveLastChanges(): boolean {
    let result: boolean;
    let strLastChanges: string;

    try {
      strLastChanges = JSON.stringify(this.lastChange);

      result = this.lastChangeIdentifier != null && this.lastChangeIdentifier !== ChangelogConsts.LastChanges;
      if (result) {
        localStorage.setItem(this.lastChangeIdentifier, strLastChanges);
        this.loadLastChanges();
      }
    } catch (e) {
      console.error(e);
      result = false;
    }

    return result;
  }

  /**
   * Restituisce le variabili presenti in LastChange.
   * @param propertyName nome della proprietà da modificare in LastChange, prelevabile da LastChangeProperties.
   */
  public getLastChangelog(propertyName: string): any {
    return this.lastChange != null ? this.lastChange[propertyName] : null;
  }

  /**
   * Imposta le variabili presenti in LastChange.
   * @param propertyName nome della proprietà da modificare in LastChange, prelevabile da LastChangeProperties.
   * @param newValue nuovo valore da assegnare.
   * @param canSave a seguito della modifica salvare immediatamente nel localStorage.
   */
  public setLastChangelog(propertyName: string, newValue: any, canSave: boolean = false): void {
    this.lastChange[propertyName] = newValue;
    if (canSave) {
      this.saveLastChanges();
    }
  }

  public canBeShown(): Observable<any> {
    return this.loadChangeLogs().map(
      (result) => {
        // Load last change...
        this.loadLastChanges();

        const isAlreadyConsulted: boolean = this.lastChange.changeLogConsulted || false;
        const isVersionChanged: boolean = this.changeLogs != null && this.changeLogs.length > 0 && this.changeLogs[0].version !== this.lastChange.version;
        // ISBS-142 - CR - const isAlreadyShown : boolean = this.lastChange.changeLogAlreadyShown;
        const isAlreadyShown: boolean = false;

        let bResult: boolean = isVersionChanged || !isAlreadyConsulted;

        this.ChangeLogOnConsole(isAlreadyShown, isVersionChanged, isAlreadyConsulted, bResult);

        if (bResult) {
          bResult = bResult && !isAlreadyShown;

          let nrProps: number = Object.keys(this.lastChange).length;
          if (this.lastChange == null || nrProps != 3) {
            this.lastChange = this.createLastChange();
          }

          // ISBS-142 - CR - this.lastChange.changeLogAlreadyShown = true;
          this.lastChange.changeLogChanged = false;

          if (this.changeLogs && this.changeLogs.length > 0) {
            this.lastChange.version = this.changeLogs[0].version;
          }

          this.saveLastChanges();
        }

        return bResult;
      },
      (error) => {
        console.error(error);
        return false;
      }
    );
  }

  /**
     * Get changelog
     * @param isCustomerPortal if true load changelog for Customer portal, standard one otherwise
     */
  public getChangelog() {
    const url = assetUrl('/changelogs.json');
    return this.http.get<ChangeLogsModel>(`${url}?t=${Date.now()}`);
  }
}

